// @ts-nocheck
import PropTypes from "prop-types";
import React from "react";
import className from "./PullDownItem.module.scss";

/**
 * @arg {PropTypes.InferProps.<typeof PullDownItem.propTypes>} props
 * @return {ReturnType.<React.FC>}
 */
export default function PullDownItem({ children, value, onClick, style }) {
  return (
    <button className={className.button} type="button" value={value} onClick={onClick} style={style}>
      {children}
    </button>
  );
}

PullDownItem.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};
